import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'carpa-data-table',
    templateUrl: './carpa-data-table.component.html',
    styleUrls: ['./carpa-data-table.component.css'],
    standalone: false
})
export class CarpaDataTableComponent<T> implements OnInit, OnChanges {
	@Input() data: T[] = [];
	@Input() columns: { key: string; label: string }[] = [];
	@Input() itemsPerPageOptions: number[] = [5, 10, 25, 50];
	@Input() actionHandler: (action: string, item: T) => void;
	@Output() selectedItemChange = new EventEmitter<T>();

	sortedData: T[] = [];
	currentPage: number = 1;
	itemsPerPage: number = 10;
	totalPages: number = 0;
	sortColumn: keyof T;
	sortDirection: 'asc' | 'desc' = 'asc';
	selectedItem: T | null = null;

	get totalPagesArray(): number[] {
		return Array(this.totalPages)
			.fill(0)
			.map((x, i) => i + 1);
	}

	ngOnInit(): void {
		this.sortedData = [...this.data];
		this.calculateTotalPages();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.data) {
			this.sortedData = [...this.data];
			this.calculateTotalPages();
		}
	}

	calculateTotalPages(): void {
		this.totalPages = Math.ceil(this.sortedData.length / this.itemsPerPage);
	}

	sort(column: keyof T): void {
		if (this.sortColumn === column) {
			this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
		} else {
			this.sortDirection = 'asc';
			this.sortColumn = column;
		}
		this.sortedData.sort((a, b) => {
			const aValue = a[column];
			const bValue = b[column];
			return this.sortDirection === 'asc' ? (aValue > bValue ? 1 : -1) : aValue < bValue ? 1 : -1;
		});
		this.currentPage = 1;
		this.calculateTotalPages();
	}

	get paginatedData(): T[] {
		const start = (this.currentPage - 1) * this.itemsPerPage;
		const end = start + this.itemsPerPage;
		return this.sortedData.slice(start, end);
	}

	changePage(page: number): void {
		if (page >= 1 && page <= this.totalPages) {
			this.currentPage = page;
		}
	}

	onItemsPerPageChange(event: Event): void {
		const selectElement = event.target as HTMLSelectElement;
		this.itemsPerPage = Number(selectElement.value);
		this.currentPage = 1;
		this.calculateTotalPages();
	}

	handleAction(action: string, item: T): void {
		if (this.actionHandler) {
			this.actionHandler(action, item);
		}
	}

	selectRow(item: T): void {
		this.selectedItem = item;
		this.selectedItemChange.emit(this.selectedItem);
	}
}
